import { useRecordContext } from "react-admin";
import { fmtDateTimeDE } from "../components/raFormat";
import { RecordMetaCard } from "../../layout";

export function PersonMeta() {
  const r = useRecordContext<any>();
  if (!r) return null;

  return (
    <RecordMetaCard
      title="Systemdaten"
      rows={[
        { label: "Erstellt", value: fmtDateTimeDE(r.createdAt) },
        { label: "Aktualisiert", value: fmtDateTimeDE(r.updatedAt) },
        { label: "Version", value: r.version ?? "—" },
      ]}
    />
  );
}
